import {
    AccrualMatchAuditItem,
    AccrualMatchAuditItemType,
    AccrualMatchAuditSnapshot,
} from "@common/schemas/domains/accrualReview/accrual-match-audit-log.schema";
import {
    MatchableItem,
    MatchItemType,
} from "@components/accounting/transactionMatch/types";

function mapItem(item: AccrualMatchAuditItem): MatchableItem {
    const base: MatchableItem = {
        id: item.id,
        date: new Date(item.date),
        type: toMatchItemType(item.type),
        counterpartyName: item.counterpartyName,
        description: item.description,
        accountIds: item.accountIds,
        classIds: item.classIds,
        amount: item.amount,
        openAmount: item.openAmount ?? null,
        entityId: item.entityId,
        entity: item.entity,
    };
    return base;
}

function toMatchItemType(type: AccrualMatchAuditItemType): MatchItemType {
    switch (type) {
        case AccrualMatchAuditItemType.INVOICE_LINE_ITEM:
            return MatchItemType.INVOICE;
        case AccrualMatchAuditItemType.BILL_LINE_ITEM:
            return MatchItemType.BILL;
        case AccrualMatchAuditItemType.TRANSACTION:
        default:
            return MatchItemType.TRANSACTION;
    }
}

export function mapSnapshotToSourceMatchableItem(
    snapshot: AccrualMatchAuditSnapshot,
): MatchableItem {
    return mapItem(snapshot.transaction);
}

export function mapSnapshotToItemsMatchableItems(
    snapshot: AccrualMatchAuditSnapshot,
): MatchableItem[] {
    return snapshot.items.map(mapItem);
}
